import { Helmet } from "react-helmet-async";

/**
 * Synchronous noindex meta for /admin/*.
 *
 * Rendered OUTSIDE the lazy AdminWrapper Suspense boundary so the
 * <meta name="robots" content="noindex, nofollow"> tag is present in
 * the initial synchronous render — and therefore in the prerendered
 * HTML produced by LovableHTML. AdminLayout also emits this same tag
 * post-auth; this component guarantees it exists for crawlers that
 * never reach the authenticated layout.
 */
export function AdminNoIndex() {
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
